import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import Page from "components/page/Page";
import FormLayout from "components/form/FormLayout";
import Form from "components/form/Form";

export default function TournamentLeaderboard() {
  const { t } = useTranslation();
  const { tournamentId, scoresheetId } = useParams<{ tournamentId: string; scoresheetId: string }>();

  function printScoresheet(id: number) {
    console.log("PRINT SCORESHEET", id);
    // const res = await PrintScoresheet({ scoresheet_id: id }, true);
    // console.log(res);  //DEBUG
  }

  const primaryAction = {
    content: t("Print"),
    action: () => printScoresheet(Number(scoresheetId)),
  };

  return (
    <Page
      title={t("Leaderboard")}
      primaryAction={primaryAction}
      subActions={[{}]}
      narrow
      breadcrumbs={[
        {
          prefix: true,
          label: t("Scoresheets"),
          url: "/admin/tournament/" + tournamentId + "/scoring",
        },
      ]}
    >
      <Form>
        <FormLayout></FormLayout>
      </Form>
    </Page>
  );
}
